import { useSelector } from 'react-redux';
import {OfficeDataState} from '../../states/utilState'


export const useOfficeDataState = () => {
    return useSelector((state: { officeData: OfficeDataState }) => state)
};